import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "clearanceType"
  }

  return (
    <>
      <Head>
        <title>{`Clearance Sale in New Zealand | Huge Discounts | BestDeals.co.nz`}</title>
        <meta name="keywords" content={`bestdeals clearance, clearance, best deals nz, best deals, bestdeals nz, bestdeals`}></meta>
        <meta name="description" content={`Find unbeatable clearance deals at Bestdeals.co.nz! Enjoy massive discounts on a wide range of products while stocks last. Shop the clearance sale today.`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout >
        <FeaturedSection type="clearance" defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}